<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <h4 class="text-uppercase mb-0">Recovery</h4>
          <a href="/help/knowledgebase?section=recovery" target="_blank">
            <img src="/img/icons/ic_info.svg" alt="About Recovery" class="ms-2" /></a>
        </div>

        <div>
          <Datepicker id="dpRecovery" v-model="dtRange" dark range auto-range="6" :format="dtRangeFormat"
            :enable-time-picker="false" :max-date="new Date()" />
        </div>
      </div>
      <div class="col-12 mt-3">
        <recovery-by-day-section-chart v-if="chart" id="chart" header="Recovery Score Ranges" :period="dtRange"
          title="All Sections" height="360" :selected-section-id="selectedSection"
          :data-recovery-ranges="dataRecoveryRanges" :data-recovery="dataRecovery" :chart="chart" @selected-section-id="
            (selectedValue) => (selectedSection = selectedValue)
          " @selected-page="(selectedValue) => (page = selectedValue)"
          @selected-sort="(selectedValue) => (sort = selectedValue)"
          @selected-order="(selectedValue) => (order = selectedValue)" :selected-platoon-id="selectedPlatoon"
          @selected-platoon-id="
            (selectedValue) => (selectedPlatoon = selectedValue)
          " />
      </div>
    </div>

    <div class="col-12 mt-4">
      <recovery-section-chart v-if="chartRecoverySection" id="chartRecoverySection" header="Average Recovery and HRV"
        header-rhr="Average Resting Heart Rate (RHR)" :period="dtRange" title="ALPHA" height="480"
        :chart="chartRecoverySection" :chart-rhr="chartRhrSection" :selected-section-id="selectedSection"
        @selected-section-id="
          (selectedValue) => (selectedSection = selectedValue)
        " />
    </div>
  </div>
</template>
<script>
const dayjs = require("dayjs");
import Constants from "@/helpers/constants";
import ChartUtils from "@/helpers/chartUtils";
import Datepicker from "@vuepic/vue-datepicker";
import RecoveryByDaySectionChart from "./components/RecoveryByDaySectionChart.vue";
import RecoverySectionChart from "./components/RecoverySectionChart.vue";

export default {
  name: "Recovery",
  components: {
    RecoveryByDaySectionChart,
    RecoverySectionChart,
    Datepicker,
  },
  data() {
    return {
      dtRangeFormat: Constants.DATE_RANGE_FORMAT,
      page: Constants.DEFAULT_PAGE,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
      sort: "bucket",
      order: "desc",
      selectedSection: Constants.DEFAULT_SECTION,
      dtRange: [dayjs().subtract(6, "days"), dayjs()],
      dataRecoveryRanges: [],
      dataRecovery: [],
      dataAvgRecoveryAndHrv: [],
      chart: {
        labels: [],
        datasets: [],
      },
      chartRecoverySection: {
        labels: [],
        datasets: [],
      },
      chartRhrSection: {
        labels: [],
        datasets: [],
      },
      selectedPlatoon: Constants.DEFAULT_SECTION,
    };
  },
  watch: {
    dtRange() {
      if (!this.dtRange) {
        this.dtRange = [dayjs().subtract(6, "days"), dayjs()];
      }
      this.getDataRecoveryRanges();
    },
    selectedSection() {
      this.getDataRecoveryRanges();
    },
    selectedPlatoon() {
      this.getDataRecoveryRanges();
    },
    page() {
      this.getDataRecovery();
    },
    sort() {
      this.getDataRecovery();
    },
    order() {
      this.getDataRecovery();
    },
  },
  mounted() {
    this.getDataRecoveryRanges();
  },
  methods: {
    getDataRecoveryRanges() {
      this.$store
        .dispatch("data/recoveryRangesBySection", {
          section_id: this.selectedSection || -1,
          dt_from: dayjs(this.dtRange[0])
            .utc()
            .startOf("day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.dtRange[1])
            .utc()
            .endOf("day")
            .format(Constants.BUCKET_FORMAT),
          platoon_id: this.selectedPlatoon,
        })
        .then((data) => {
          this.dataRecoveryRanges = data.data;
          this.updateChartData();
          this.getDataRecovery();
        });
    },
    getDataRecovery() {
      this.$store
        .dispatch("data/recoveryDataBySection", {
          page: this.page,
          page_size: this.pageSize,
          sort: this.sort,
          order: this.order,
          section_id: this.selectedSection || -1,
          dt_from: dayjs(this.dtRange[0]).utc().format(Constants.DB_FORMAT),
          dt_to: dayjs(this.dtRange[1]).utc().format(Constants.DB_FORMAT),
          platoon_id: this.selectedPlatoon,
        })
        .then((data) => {
          this.dataRecovery = data.data;
          this.getDataAvgRecoveryAndHrv();
        });
    },
    getDataAvgRecoveryAndHrv() {
      this.$store
        .dispatch("data/avgRecoveryAndHrvBySection", {
          section_id: this.selectedSection || -1,
          dt_from: dayjs(this.dtRange[0]).utc().format(Constants.DB_FORMAT),
          dt_to: dayjs(this.dtRange[1]).utc().format(Constants.DB_FORMAT),
          platoon_id: this.selectedPlatoon,
        })
        .then((data) => {
          this.dataAvgRecoveryAndHrv = data.data;
          this.updateRecoverySectionChart();
          this.updateRhrSectionChart();
        });
    },
    updateChartData() {
      this.chart = Object.assign(
        {},
        ChartUtils.dataRangesChart(this.dataRecoveryRanges)
      );
    },
    updateRecoverySectionChart() {
      this.chartRecoverySection = Object.assign(
        {},
        ChartUtils.avgRecoveryAndHrvChart(this.dataAvgRecoveryAndHrv)
      );
    },
    updateRhrSectionChart() {
      this.chartRhrSection = Object.assign(
        {},
        ChartUtils.avgRhrChart(this.dataAvgRecoveryAndHrv)
      );
    },
  },
};
</script>
